import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useHotel } from "../contexts/HotelContext";

// Mock API
const api = {
  getOffer: async (offerId: string) => {
    console.log(`Fetching offer ${offerId}...`);
    // This is a mock. In a real app, you'd fetch from your backend.
    return {
      id: offerId,
      title: "Corporate Event Package",
      clientName: "Initech Corp",
      checkInDate: "2025-09-10",
      checkOutDate: "2025-09-12",
      numberOfGuests: 25,
      totalAmount: 15000,
      appliedPersonDiscount: 5,
      appliedStayLengthDiscount: 2,
      totalDiscount: 7,
      finalAmount: 13950,
      status: "Draft",
      components: [
        {
          name: "Pokój 2-os. comfort",
          quantity: 10,
          unitPrice: 400,
          finalPrice: 4000,
        },
        {
          name: "Obiadokolacja bufet",
          quantity: 25,
          unitPrice: 93,
          finalPrice: 2325,
        },
        {
          name: "Sala konferencyjna",
          quantity: 2,
          unitPrice: 500,
          finalPrice: 1000,
        },
      ],
    };
  },
};

const OfferDetails: React.FC = () => {
  const { currentHost } = useHotel();
  const { id } = useParams<{ id: string }>();
  const [offer, setOffer] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const getHotelDisplayName = () => {
    if (currentHost === "demo.hotelb2b.com") {
      return "Demo Hotel";
    }
    const subdomain = currentHost.split(".")[0];
    return `Hotel ${subdomain.charAt(0).toUpperCase() + subdomain.slice(1)}`;
  };

  useEffect(() => {
    if (id) {
      api.getOffer(id).then((data) => {
        setOffer(data);
        setLoading(false);
      });
    }
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!offer) {
    return <div>Offer not found.</div>;
  }

  return (
    <div className="min-h-screen bg-neutral-50" data-testid="offer-details">
      <nav className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-neutral-900">
                {getHotelDisplayName()} - B2B Offers
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <Link
                to="/offers"
                className="btn-secondary"
                data-testid="back-to-offers"
              >
                Back to Offers
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto py-8 sm:px-6 lg:px-8">
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6">
            <h1
              className="text-3xl font-bold text-neutral-900"
              data-testid="offer-title"
            >
              {offer.title}
            </h1>
            <p
              className="mt-1 max-w-2xl text-sm text-neutral-500"
              data-testid="offer-description"
            >
              Offer for{" "}
              <span data-testid="client-name">{offer.clientName}</span>
            </p>
          </div>
          <div className="border-t border-neutral-200">
            <dl>{/* Details Section */}</dl>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OfferDetails;
